<div class="d-none d-md-block">
<div class="container-fluid fade-in">
  <div class="welcome-section mb-4 fade-in">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h2 class="fw-bold">Budgeting Dashboard</h2>
        <h4 class="welcome-text">
          Make and manage budgets and get AI insights
        </h4>
      </div>

      <div class="text-end">
        <small class="text-muted d-block">Current User:</small>
        <h6 class="mb-0">{{fullName}}</h6>
        <small class="text-muted d-block">{{tenantName}}</small>
      </div>
    </div>
  </div>

  <!-- Debug Panel: Actuals inclusion/exclusion per budget -->
  <div class="row" *ngIf="showDebugPanel">
    <div class="col-12" style="padding: 6px">
      <div class="card">
        <div class="card-header d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <div class="chart-icon-container me-3">
              <i class="bi bi-bug"></i>
            </div>
            <h3 class="chart-title mb-0">Actuals Debug</h3>
          </div>
          <small class="text-muted">Shows which ActualBudgetCost rows were used per budget</small>
        </div>
        <div class="card-body">
          <div *ngIf="filteredBudgets.length === 0" class="text-muted">No budgets available for current filters.</div>

          <div *ngFor="let budget of filteredBudgets" class="mb-3 border rounded p-2">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <div>
                <strong>{{ budget.budgetName }}</strong>
                <small class="text-muted">(ID: {{ budget.budgetID }})</small>
              </div>
              <div>
                <span class="badge bg-info text-dark me-2">Line Period IDs: {{ actualsDebugByBudget[budget.budgetID]?.linePeriodIds?.join(', ') || '-' }}</span>
                <span class="badge bg-primary text-light me-2">Expanded Month IDs: {{ actualsDebugByBudget[budget.budgetID]?.expandedPeriodIds?.join(', ') || '-' }}</span>
                <span class="badge bg-light text-dark">Allowed Period IDs: {{ actualsDebugByBudget[budget.budgetID]?.allowedPeriodIds?.join(', ') || '-' }}</span>
              </div>
            </div>

            <div class="row g-2">
              <div class="col-12 col-md-6">
                <h6 class="mb-1">Included Rows</h6>
                <div class="table-responsive">
                  <table class="table table-sm table-striped mb-2">
                    <thead>
                      <tr>
                        <th>Period</th>
                        <th class="text-end">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of (actualsDebugByBudget[budget.budgetID]?.included || [])">
                        <td>{{ row.period }}</td>
                        <td class="text-end">{{ row.amount | currency: 'ZAR' : 'symbol' : '1.2-2' }}</td>
                      </tr>
                      <tr *ngIf="!((actualsDebugByBudget[budget.budgetID]?.included?.length) ?? 0)">
                        <td colspan="2" class="text-muted">No included rows for current filters/periods.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="text-end">
                  <strong>Sum:</strong>
                  <span>{{ (actualsDebugByBudget[budget.budgetID]?.sum || 0) | currency: 'ZAR' : 'symbol' : '1.2-2' }}</span>
                </div>
              </div>

              <div class="col-12 col-md-6">
                <h6 class="mb-1">Excluded Rows (period not in budget/filters)</h6>
                <div class="table-responsive">
                  <table class="table table-sm table-striped mb-0">
                    <thead>
                      <tr>
                        <th>Period</th>
                        <th class="text-end">Amount</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of (actualsDebugByBudget[budget.budgetID]?.excluded || [])">
                        <td>{{ row.period }}</td>
                        <td class="text-end">{{ row.amount | currency: 'ZAR' : 'symbol' : '1.2-2' }}</td>
                      </tr>
                      <tr *ngIf="!((actualsDebugByBudget[budget.budgetID]?.excluded?.length) ?? 0)">
                        <td colspan="2" class="text-muted">No excluded rows.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
  <!-- First Row: Budget vs Actual, Statistics, Blank -->
  <div class="dashboard-cards fade-in">
    <!-- Total Budget Card -->
    <div class="metric-card main">
      <div class="card-content">
        <div class="icon-container">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5 21V5C5 4.46957 5.21071 3.96086 5.58579 3.58579C5.96086 3.21071 6.46957 3 7 3H17C17.5304 3 18.0391 3.21071 18.4142 3.58579C18.7893 3.96086 19 4.46957 19 5V21L16 19L14 21L12 19L10 21L8 19L5 21Z"
              stroke="#007A8F" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M9 7H15M9 11H15M9 15H13" stroke="#007A8F" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
        <div class="metric-info">
          <p class="metric-label">Total Budget</p>
          <h2 class="metric-value">
            {{
            calculateCurrentMonthTotalBudget()
            | currency : "ZAR" : "symbol" : "1.2-2"
            }}
          </h2>
        </div>
      </div>
    </div>

    <!-- Utilized Budget Card -->
    <div class="metric-card warning">
      <div class="card-content">
        <div class="icon-container">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 8V16M8 12H16M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
              stroke="#6C7A3E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </div>
        <div class="metric-info">
          <p class="metric-label">Total Variance</p>
          <p class="metric-value" [ngClass]="{
            positive: calculateCurrentMonthTotalBudget() - getCurrentMonthTotalActualCosts() > 0,
            negative: calculateCurrentMonthTotalBudget() - getCurrentMonthTotalActualCosts() < 0
          }">{{ calculateCurrentMonthTotalBudget() - getCurrentMonthTotalActualCosts() | currency : "ZAR" : "symbol" :
            "1.2-2"}}</p>
        </div>
      </div>
    </div>

    <!-- Total Actual Cost Card (reacts to filters) -->
    <div class="metric-card success" [ngClass]="{
        positive: getCurrentMonthTotalActualCosts() > calculateCurrentMonthTotalBudget(),
        negative: getCurrentMonthTotalActualCosts() < calculateCurrentMonthTotalBudget()
      }">
      <div class="card-content">
        <div class="icon-container" style="background-color: #b0213c1a" [ngClass]="
            getCurrentMonthTotalActualCosts() < calculateCurrentMonthTotalBudget()
              ? 'warning'
              : 'success'
          ">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
              stroke="#B0213C" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            <path d="M8 14L12 10L16 14" stroke="#B0213C" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </div>
        <div class="metric-info">
          <p class="metric-label">Total Actual Cost</p>
          <h2 class="metric-value">
            {{
            getCurrentMonthTotalActualCosts()
            | currency : "ZAR" : "symbol" : "1.2-2"
            }}
          </h2>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid">
    <div class="row">
      <div class="col-12" style="padding: 6px">
        <div class="card fade-in filter-card">
          <div class="card-header d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <div class="chart-icon-container me-3">
                <i class="bi bi-funnel"></i>
              </div>
              <h3 class="chart-title mb-0">Filters</h3>
            </div>
            <div class="d-flex align-items-center gap-2">
              <div *ngIf="isLoading" class="d-flex align-items-center text-muted">
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Loading...
              </div>
              <!-- <button type="button" class="btn btn-sm btn-outline-secondary" (click)="showDebugPanel = !showDebugPanel" [attr.aria-pressed]="showDebugPanel">
                <i class="bi" [ngClass]="showDebugPanel ? 'bi-bug-fill' : 'bi-bug'" aria-hidden="true"></i>
                {{ showDebugPanel ? 'Hide Debug' : 'Show Debug' }}
              </button> -->
            </div>
          </div>
          <div class="card-body">
            <div class="row g-2 align-items-end">
              <div class="col-12 col-md-3 col-lg-2">
                <label class="form-label mb-1">Budget Type</label>
                <select class="form-select form-select-sm" [(ngModel)]="selectedBudgetType"
                        (ngModelChange)="onBudgetTypeChange($event)" [disabled]="isLoading">
                  <option value="all">All Types</option>
                  <option value="monthly">Monthly</option>
                  <option value="quarterly">Quarterly</option>
                  <option value="annually">Annually</option>

                </select>
              </div>

              <div class="col">
                <label class="form-label mb-1">Date Range</label>

                <!-- Monthly selector -->
                <div *ngIf="selectedBudgetType === 'monthly'" class="d-flex flex-wrap gap-2">
                  <select class="form-select form-select-sm w-auto" [(ngModel)]="selectedMonth" (ngModelChange)="onMonthChange($event)">
                    <option *ngFor="let month of availableMonths" [value]="month.value">{{ month.label }}</option>
                  </select>
                  <select class="form-select form-select-sm w-auto" [(ngModel)]="selectedYear" (ngModelChange)="onMonthChange(selectedMonth)">
                    <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
                  </select>
                </div>

                <!-- Quarterly selector -->
                <div *ngIf="selectedBudgetType === 'quarterly'" class="d-flex flex-wrap gap-2">
                  <select class="form-select form-select-sm w-auto" [(ngModel)]="selectedQuarter" (ngModelChange)="onQuarterChange($event)">
                    <option *ngFor="let quarter of availableQuarters" [value]="quarter.value">{{ quarter.label }}</option>
                  </select>
                  <select class="form-select form-select-sm w-auto" [(ngModel)]="selectedYear" (ngModelChange)="onQuarterChange(selectedQuarter)">
                    <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
                  </select>
                </div>

                <!-- Annual selector -->
                <div *ngIf="selectedBudgetType === 'annually'" class="d-flex flex-wrap gap-2">
                  <select class="form-select form-select-sm w-auto" [(ngModel)]="selectedYear" (ngModelChange)="onYearChangeForType($event)">
                    <option *ngFor="let year of availableYears" [value]="year">{{ year }}</option>
                  </select>
                </div>

                <!-- Default date range for 'all' and 'per-item' -->
                <div *ngIf="selectedBudgetType === 'all' || selectedBudgetType === 'per-item'" class="input-group input-group-sm">
                  <span class="input-group-text">From</span>
                  <input type="date" class="form-control"
                         [value]="dateToInput(dateRange.start)"
                         (change)="onStartDateChange(($any($event.target)).value)" [disabled]="isLoading" />
                  <span class="input-group-text">to</span>
                  <input type="date" class="form-control"
                         [value]="dateToInput(dateRange.end)"
                         (change)="onEndDateChange(($any($event.target)).value)" [disabled]="isLoading" />
                </div>
              </div>

              <div class="col-auto">
                <button class="btn btn-sm btn-grey-gradient" (click)="resetDateRange()" [disabled]="isLoading">
                  Reset
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-9 d-flex" style="padding: 6px">
        <div class="card flex-grow-1">
          <div class="d-flex justify-content-between align-items-center pb-3 mb-3 chart-header-border">
            <div class="d-flex align-items-center">
              <div class="chart-icon-container me-3">
                <i class="bi bi-bar-chart"></i>
              </div>
              <h3 class="chart-title mb-0">Budget vs Actual</h3>
            </div>
            <div class="d-flex align-items-center gap-2" *ngIf="filteredBudgets.length > 0">
              <div class="d-flex align-items-center me-2">
                <label class="me-2 mb-0 small text-muted">Bars per page</label>
                <select class="form-select form-select-sm w-auto" [(ngModel)]="pageSize" (ngModelChange)="onPageSizeChange($event)">
                  <option [ngValue]="5">5</option>
                  <option [ngValue]="10">10</option>
                  <option [ngValue]="20">20</option>
                  <option [ngValue]="50">50</option>
                </select>
              </div>
              <div class="small text-muted me-2">
                Showing {{ pageStartDisplay }}–{{ pageEndDisplay }} of {{ filteredBudgets.length }}
              </div>
              <div class="btn-group btn-group-sm" role="group" aria-label="Pagination">
                <button class="btn btn-sm btn-teal-gradient" (click)="goToPrevPage()" [disabled]="currentPage === 1 || isLoading">
                  <i class="bi bi-chevron-left"></i>
                </button>
                <button class="btn btn-teal-gradient" (click)="goToNextPage()" [disabled]="currentPage >= totalPages || isLoading">
                  <i class="bi bi-chevron-right"></i>
                </button>
              </div>

            </div>
          </div>
          <div class="card-body">
            <div *ngIf="filteredBudgets.length === 0" class="d-flex align-items-center justify-content-center chart-empty-state">
              <div class="text-center p-4">
                <i class="bi bi-bar-chart fs-1 text-muted mb-2"></i>
                <p class="mb-1">No budgets to display</p>
                <small class="text-muted">Add budgets or adjust filters/date range to see the chart</small>
              </div>
            </div>
            <div class="chart-container budget-chart" *ngIf="filteredBudgets.length > 0">
              <div class="chart-overlay" *ngIf="isLoading" aria-live="polite" aria-busy="true">
                <div class="app-loading-spinner" role="status" aria-label="Loading chart"></div>
              </div>
              <canvas baseChart [data]="budgetVsActualChartData" [options]="chartOptions" [type]="'bar'"
                style="height: 450px !important">
              </canvas>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 col-md-3" style="padding: 6px; width: 100%">
        <app-aivor-insights
          [filterStart]="dateRange.start"
          [filterEnd]="dateRange.end"
          [selectedBudgetType]="selectedBudgetType"
        ></app-aivor-insights>
      </div>
    </div>
  </div>

  <div class="dashboard-cards">
    <div class="metric-card">
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex align-items-center">
          <div class="chart-icon-container me-3">
            <i class="bi bi-clipboard-data"></i>
          </div>
          <h3 class="chart-title mb-0">Budget and Variance</h3>
        </div>
        <div class="d-flex align-items-center" style="gap: 8px;">

          <button class="btn btn-teal-gradient" (click)="openBudgetModal()">
            <i class="bi bi-plus-lg me-2"></i>Add New
          </button>
        </div>
      </div>
      <div *ngIf="filteredBudgets.length === 0" class="text-center p-4 text-muted">
        <i class="bi bi-clipboard-data fs-2 d-block mb-2"></i>
        <div>No budgets found for the selected filters/date range</div>
        <small>Click "Add New" to create a budget</small>
      </div>

      <div class="table-wrapper" *ngIf="filteredBudgets.length > 0">
        <table class="table table-hover align-middle mb-0">
          <thead class="table-header">
            <tr>
              <th class="fw-bold">Budget</th>
              <th class="fw-bold">Planned</th>
              <th class="fw-bold">Actual</th>
              <th class="fw-bold">Variance</th>

              <th class="fw-bold">Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr class="cursor-pointer" *ngFor="let budget of filteredBudgets">
              <td>
                <span class="category-badge" style="color: #495057">
                  {{ budget.budgetName }}
                </span>
              </td>
              <td>
                {{
                calculateTotalLineItemAmount(budget)
                | currency : "ZAR" : "symbol" : "1.2-2"
                }}
              </td>
              <td>
                {{
                budget.totalActualCostFromInventory
                | currency : "ZAR" : "symbol" : "1.2-2"
                }}

              </td>
              <td>
                <span class="variance-badge" [ngClass]="{
                    'variance-low':
                      calculateTotalLineItemAmount(budget) >
                      (budget.totalActualCostFromInventory ?? 0),
                    'variance-high':
                      calculateTotalLineItemAmount(budget) <
                      (budget.totalActualCostFromInventory ?? 0)
                  }">
                  <i *ngIf="
                      calculateTotalLineItemAmount(budget) >
                      (budget.totalActualCostFromInventory ?? 0)
                    " class="bi bi-arrow-up me-1"></i>
                  <i *ngIf="
                      calculateTotalLineItemAmount(budget) <
                      (budget.totalActualCostFromInventory ?? 0)
                    " class="bi bi-arrow-down me-1"></i>
                  {{
                  calculateTotalLineItemAmount(budget) -
                  (budget.totalActualCostFromInventory ?? 0)
                  | currency : "ZAR" : "symbol" : "1.2-2"
                  }}
                </span>
              </td>

              <td class="text-nowrap">
                <button class="btn btn-outline-primary" (click)="openBudgetModal(budget)">
                  <i class="bi bi-pencil-square"></i>
                </button>
                <button class="btn btn-outline-primary danger" (click)="openDeleteBudgetModal(budget)">
                  <i class="bi bi-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- Third Row: Other Cards (Evenly Spaced) -->

  <div class="modal" [ngClass]="{ 'd-block': showBudgetModal }" style="background: #00000080">
    <div class="modal-dialog modal-lg modal-dialog-centered" style="height: 80%">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ editMode ? "Edit Budget" : "Add Budget" }}
          </h5>
          <button type="button" class="close-button" (click)="closeBudgetModal()">x</button>
        </div>
        <div class="modal-body">
          <div class="form-section supplier-section mb-4 card">
            <form>
              <label>Budget Name:</label>
              <input type="text" class="form-control" id="budgetName" name="budgetName"
                [(ngModel)]="budgetForm.budgetName" required [disabled]="isLoading" />
              <label for="budgetType" class="form-label">Budget Type</label>
              <select class="form-select" id="budgetType" name="budgetType" [(ngModel)]="budgetForm.budgetType"
                (ngModelChange)="onModalBudgetTypeChange($event)" [disabled]="isLoading">
                <option value="Monthly">Monthly</option>
                <option value="Quarterly">Quarterly</option>
                <option value="Annually">Annually</option>
              </select>
              <div class="col-md-4">
                <label for="dateRange" class="form-label fw-medium">Date Range</label>

                <!-- Monthly selector -->
                <div *ngIf="budgetForm.budgetType === 'Monthly'" class="d-flex gap-2">
                  <select class="form-select" name="modalMonth" [(ngModel)]="selectedMonth" (ngModelChange)="onMonthChange($event)">
                    <option *ngFor="let month of availableMonths" [ngValue]="month.value">{{ month.label }}</option>
                  </select>
                  <select class="form-select" name="modalMonthYear" style="max-width: 120px" [(ngModel)]="selectedYear" (ngModelChange)="onMonthChange(selectedMonth)">
                    <option *ngFor="let year of availableYears" [ngValue]="year">{{ year }}</option>
                  </select>
                </div>

                <!-- Quarterly selector -->
                <div *ngIf="budgetForm.budgetType === 'Quarterly'" class="d-flex gap-2">
                  <select class="form-select" name="modalQuarter" [(ngModel)]="selectedQuarter" (ngModelChange)="onQuarterChange($event)">
                    <option *ngFor="let quarter of availableQuarters" [ngValue]="quarter.value">{{ quarter.label }}</option>
                  </select>
                  <select class="form-select" name="modalQuarterYear" style="max-width: 120px" [(ngModel)]="selectedYear" (ngModelChange)="onQuarterChange(selectedQuarter)">
                    <option *ngFor="let year of availableYears" [ngValue]="year">{{ year }}</option>
                  </select>
                </div>

                <!-- Annual selector -->
                <div *ngIf="budgetForm.budgetType === 'Annually'">
                  <select class="form-select" name="modalAnnualYear" [(ngModel)]="selectedYear" (ngModelChange)="onModalBudgetTypeChange('Annually')">
                    <option *ngFor="let year of availableYears" [ngValue]="year">{{ year }}</option>
                  </select>
                </div>

                <!-- Default date range for 'per-item' -->
                <div *ngIf="budgetForm.budgetType === 'per-item'" class="input-group">
                  <input type="date" class="form-control" [value]="dateToInput(dateRange.start)"
                         (change)="onStartDateChange(($any($event.target)).value)" [disabled]="isLoading" id="startDate" />
                  <span class="input-group-text">to</span>
                  <input type="date" class="form-control" [value]="dateToInput(dateRange.end)"
                         (change)="onEndDateChange(($any($event.target)).value)" [disabled]="isLoading" id="endDate" />
                </div>
              </div>


              <label for="description" class="form-label">Description</label>
              <textarea class="form-control" id="description" name="description" rows="3"
                [(ngModel)]="budgetForm.description" [disabled]="isLoading"></textarea>
            </form>
          </div>


        <div class="form-section bom-section mb-4 card">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h5 class="mb-0">Budget Lines</h5>
            <button class="btn btn-gradient-primary m-2" (click)="addNewBudgetLine()" [disabled]="isLoading || fiscalPeriods.length === 0">
              <i class="bi bi-plus-circle"></i>
              <span>Add Line</span>
            </button>
          </div>

          <div *ngIf="fiscalPeriods.length === 0" class="alert alert-warning mb-3">
            No fiscal periods overlap the selected date range. Adjust the date range (top of page) or reset to current year to add budget lines.
          </div>

          <!-- Budget Lines Table -->
          <div class="table-responsive mb-3" *ngIf="budgetForm.lineItems?.length">
            <table class="table table-sm table-hover budget-lines-table">
              <colgroup>
                <ng-container *ngIf="budgetForm.budgetType === 'per-item'">
                  <col style="width: 25%" />
                </ng-container>
                <col style="width: 20%" />
                <col style="width: 20%" />
                <col style="width: 30%" />
                <col style="width: 5%" />
              </colgroup>
              <thead>
                <tr>
                  <th scope="col" *ngIf="budgetForm.budgetType === 'per-item'">
                    Item
                  </th>
                  <th>Planned Amount</th>
                  <th>Period</th>
                  <th>Notes</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let line of budgetForm.lineItems; let i = index" class="align-middle">
                  <td *ngIf="budgetForm.budgetType === 'per-item'" class="py-1">
                    <select class="form-select form-select-sm" [(ngModel)]="line.itemID" name="line_itemID_{{ i }}"
                      style="min-width: 150px">
                      <option [ngValue]="null">Select Product</option>
                      <option *ngFor="let item of itemsProducts" [value]="item.itemID">
                        {{ item.itemName }}
                      </option>
                    </select>
                  </td>
                  <td class="py-1">
                    <div class="d-flex align-items-center">
                      <span class="me-2">R</span>
                      <input type="number" class="form-control form-control-sm" [(ngModel)]="line.budgetAmount"
                        name="amount-{{ i }}" step="0.01" min="0" style="width: 100%" required />
                    </div>
                  </td>
                  <td class="py-1">
                    <select class="form-select form-select-sm" [(ngModel)]="line.fiscalPeriodID" name="period-{{ i }}"
                      [disabled]="fiscalPeriods.length === 0" required>
                      <option *ngFor="let period of fiscalPeriods" [ngValue]="period.fiscalPeriodID">
                        {{ (period.startDate || period.StartDate) | date : 'MMM yyyy' }}
                      </option>
                    </select>
                  </td>
                  <td class="py-1">
                    <input type="text" class="form-control form-control-sm" [(ngModel)]="line.notes"
                      name="notes-{{ i }}" placeholder="Notes" style="min-width: 120px" />
                  </td>
                  <td class="text-center py-1">
                    <button type="button" class="btn btn-sm btn-outline-danger p-1" (click)="removeBudgetLine(i)"
                      title="Remove line">
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngIf="!budgetForm.lineItems?.length" class="alert alert-info">
            No budget lines added yet. Click 'Add Line' to add one.
          </div>
        </div>
      </div>
        <div class="modal-footer">
          <button class="btn btn-gradient-secondary" (click)="closeBudgetModal()">
            Cancel
          </button>

          <button class="btn btn-gradient-primary" (click)="saveBudget()" [disabled]="isLoading || fiscalPeriods.length === 0 || hasInvalidBudgetLines()"
            title="{{ fiscalPeriods.length === 0 ? 'No fiscal periods available for the selected date range' : '' }}">
            {{ editMode ? "Update" : "Save" }}
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- End of modal -->

  <!-- Delete Budget Confirmation Modal -->
  <div class="modal" [ngClass]="{ 'd-block': showDeleteBudgetModal }" style="background: #00000080">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Delete Budget</h5>
          <button type="button" class="close-button" (click)="closeDeleteBudgetModal()">x</button>
        </div>
        <div class="modal-body">
          <p>
            Are you sure you want to delete the budget
            "{{ selectedBudgetToDelete?.budgetName }}" and all its associated budget lines?
            This action cannot be undone.
          </p>
        </div>
        <div class="modal-footer">
          <button class="btn btn-gradient-secondary" (click)="closeDeleteBudgetModal()">
            Cancel
          </button>
          <button class="btn btn-danger" (click)="confirmDeleteBudget()">
            Delete
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- End Delete Budget Confirmation Modal -->

  <div *ngIf="isProcessing" class="app-spinner-overlay">
    <div class="app-loading-spinner"></div>
  </div>
</div><!-- /container-fluid -->
</div><!-- /d-none d-md-block -->

<!-- Mobile View -->
<app-mobile-costing-view
  class="d-block d-md-none"
  [filteredBudgets]="filteredBudgets"
  [actualCostByBudgetId]="actualCostByBudgetId"
  [fiscalPeriods]="fiscalPeriods"
  [items]="items"
  [isLoading]="isLoading"
  [selectedBudgetType]="selectedBudgetType"
  [selectedMonth]="selectedMonth"
  [selectedQuarter]="selectedQuarter"
  [selectedYear]="selectedYear"
  [availableMonths]="availableMonths"
  [availableQuarters]="availableQuarters"
  [availableYears]="availableYears"
  [dateRange]="dateRange"
  [budgetVsActualChartData]="budgetVsActualChartData"
  [currentPage]="currentPage"
  [totalPages]="totalPages"
  (budgetTypeChange)="onBudgetTypeChange($event)"
  (monthChange)="onMonthChange($event)"
  (quarterChange)="onQuarterChange($event)"
  (yearChange)="onYearChangeForType($event)"
  (saveBudget)="onMobileSaveBudget($event)"
  (deleteBudget)="deleteBudget($event)"
  (prevPage)="goToPrevPage()"
  (nextPage)="goToNextPage()">
</app-mobile-costing-view>
